import React, {Component} from "react"

import session from "@irati/auth/services/session"
import loginService from "@irati/auth/services/login"
import History from "@irati/utils/history"
import Loading from "@irati/ui/src/Loading"

interface Props {}

interface State {
  load: Promise<void> | null
}

class LoginCode extends Component<Props, State> {
  state: State = {
    load: null
  }

  componentDidMount() {
    const load = this.getLoginDetails()
    this.setState({load})
  }

  getLoginDetails = () => {
    return session.getThenRemove(["accessToken"]).then(({accessToken}) => {
      if (!accessToken) throw new Error("No access token")

      return loginService.ssoLogin(accessToken).then(() => {
        History.replace("/")
      })
    })
  }

  render() {
    return <Loading load={this.state.load} />
  }
}

export default LoginCode
